export default __webpack_public_path__ + "static/media/Fiction-Red-Bookmark_clearbg.bf3da41d.png";